export default __webpack_public_path__ + "static/media/play.64cab1c2.svg";